import React, { useEffect, useState } from 'react';
import api, { getFileUrl } from '../../lib/api';
import { JsonLd } from './JsonLd';

/**
 * Site-wide Organization + WebSite JSON-LD, built from the tenant's footer and
 * contact settings. Rendered once inside the public layout so every public page
 * publishes consistent structured data for search engines.
 */
export function SiteJsonLd() {
  const [footer, setFooter] = useState(null);
  const [contact, setContact] = useState(null);

  useEffect(() => {
    api.get('/settings/footer').then((r) => setFooter(r.data)).catch(() => {});
    api.get('/settings/contact').then((r) => setContact(r.data)).catch(() => {});
  }, []);

  const origin = typeof window !== 'undefined' ? window.location.origin : '';
  const name = footer?.company_name || '';
  if (!name) return null;

  const sameAs = [footer?.facebook, footer?.instagram, footer?.twitter, footer?.linkedin, footer?.youtube]
    .filter((v) => v && String(v).startsWith('http'));
  const logo = footer?.logo_path ? getFileUrl(footer.logo_path) : undefined;

  const org = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name,
    url: origin,
    ...(logo ? { logo } : {}),
    ...(footer?.description ? { description: footer.description } : {}),
    ...(sameAs.length ? { sameAs } : {}),
  };
  const tel = contact?.phone || contact?.gsm;
  if (tel) {
    org.contactPoint = { '@type': 'ContactPoint', telephone: tel, contactType: 'customer service' };
  }
  if (contact?.address) {
    org.address = { '@type': 'PostalAddress', streetAddress: contact.address, addressCountry: 'TR' };
  }

  const website = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name,
    url: origin,
  };

  return (
    <>
      <JsonLd id="organization" data={org} />
      <JsonLd id="website" data={website} />
    </>
  );
}

export default SiteJsonLd;
